exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,400|Roboto+Slab);", ""]);
exports.push([module.id, "@import url(https://use.typekit.net/fhh8wbu.css);", ""]);

// module
exports.push([module.id, "body{font-family:circe,gill sans;color:#303030;line-height:1.6;font-weight:300;font-size:12px}h1,h2,h3,h4,h5,h6{font-family:circe;font-weight:600}h1{font-size:50px;line-height:0;font-weight:1000}h2{font-size:25px;line-height:25px;font-weight:400}h3{font-size:18px;line-height:18px;letter-spacing:-.4px}h4{font-size:14px;line-height:14px;letter-spacing:0}h5{font-size:12px;line-height:12px;letter-spacing:1px}a{text-decoration:none;color:inherit}body{min-height:100vh;margin:0;background:#f3f8fc;background-image:url(/images/svg/background.svg);background-size:220% auto;font-family:circe,Gill Sans,Gill Sans MT,Calibri,Trebuchet MS,sans-serif}body p{font-family:circe;font-weight:400;margin:0;font-size:14px;color:#303030;opacity:.9}button:active,button:focus,input:active,input:focus,select:active,select:focus,textarea:active,textarea:focus{outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/sass-loader/lib/loader.js!./resources/assets/styles/App.scss
// module id = EN6j
// module chunks = 0